export default __webpack_public_path__ + "static/media/cycling-strategy-costs.300d5754.png";